<template>
  <div>
    <i class="fa fa-check text-success"></i>
    PDF rapportage met resultaten van je {{ commercialDefinition }} t.o.v. 4 benchmarks
    (indien beschikbaar)
    <v-button
      style-type="secondary"
      size="xs"
      :text="`word.${showInfo ? 'hide' : 'show'}`"
      :rounded="true"
      @click="showInfo = !showInfo"
    />
    <v-collapse-transition>
      <div class="mt-2 p-0 card bg-dark text-white" v-if="showInfo">
        <ul class="m-4">
          <li><small>Platformgemiddelde</small></li>
          <li><small>Industriegemiddelde</small></li>
          <li><small>Gemiddelde van eigen commercials</small></li>
          <li><small>Maandgemiddelde</small></li>
        </ul>
      </div>
    </v-collapse-transition>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';

export default {
  name: 'PdfReport',
  props: {
    commercialType: {
      type: String,
      default() {
        return 'tv';
      },
    },
  },
  components: {
    'v-button': Button,
    'v-collapse-transition': CollapseTransition,
  },
  data() {
    return {
      showInfo: false,
    };
  },
  computed: {
    commercialDefinition() {
      if (this.commercialType === 'ooh') {
        return 'buitenreclame';
      }
      return 'commercial';
    },
  },
};
</script>
